module.exports = __webpack_public_path__ + "img/registerlogin_4.5308042a.jpg";